import { RegisterWidget, Widget } from '../lib/widget';
import template from './loader.html';

@RegisterWidget({tag: 'widget-loader', template: template, displayName: 'Loader', section: 'Basic'})
export class Loader extends Widget {
    protected enliven(): void {}
}